<app-search-page-home  [searchData]="searchData" [latestSearches]="latestSearches"></app-search-page-home>
<app-popular-properties [highlightsProperties]="highlightsProperties" [localAccommodations]="localAccommodations"></app-popular-properties>
<app-choose-us *ngIf="homeTexts" ></app-choose-us>
